<mat-toolbar color="primary" class="flex justify-between w-full px-2! md:px-4!">
    <div class="flex items-center grow min-w-0">
        <apcam-tooltip-custom [customMatTooltip]="closeLabel()">
            <button
                mat-icon-button
                (click)="close.emit()"
                attr.aria-label="{{ closeLabel() }}">
                <mat-icon>{{ closeIcon() }}</mat-icon>
            </button>
        </apcam-tooltip-custom>
        <apcam-tooltip-custom
            class="ms-2 min-w-0"
            display="block"
            customTooltipStyle="font-bold truncate"
            [customMatTooltip]="fileName()">
            {{ fileName() }}
        </apcam-tooltip-custom>
    </div>
    <div class="ms-auto shrink-0 flex items-center">
        @if (showDownload()) {
            <apcam-tooltip-custom
                [customMatTooltip]="
                    (contentReady()
                        ? 'shared.buttons.download'
                        : 'shared.mediaViewer.downloadBtnTooltip'
                    ) | translate
                ">
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.downloadBtnLabel' | translate
                    }}"
                    [disabled]="!contentReady()"
                    (click)="onDownload()">
                    <mat-icon>download</mat-icon>
                </button>
            </apcam-tooltip-custom>
        }
        @if (printSupported()) {
            <apcam-tooltip-custom
                [customMatTooltip]="
                    (contentReady()
                        ? 'shared.buttons.print'
                        : 'shared.mediaViewer.printBtnTooltip'
                    ) | translate
                ">
                <button
                    mat-icon-button
                    attr.aria-label="{{
                        'shared.mediaViewer.printBtnLabel' | translate
                    }}"
                    [disabled]="!contentReady()"
                    (click)="onPrint()">
                    <mat-icon>print</mat-icon>
                </button>
            </apcam-tooltip-custom>
        }
        <ng-content select="[mediaViewerToolbarActions]" />
    </div>
</mat-toolbar>
<div class="grow min-h-0 overflow-auto">
    @switch (contentType()) {
        @case (MediaViewerContentType.APPLICATION_PDF) {
            <apcam-pdfviewer
                [download]="download$"
                [fileName]="fileName()"
                [pdfUrl]="url()"
                [print]="print$"
                (pdfLoaded)="onContentLoaded()" />
        }
        @case (MediaViewerContentType.IMAGE_JPEG)
        @case (MediaViewerContentType.IMAGE_PNG) {
            <apcam-img-viewer
                [contentType]="contentType()"
                [download]="download$"
                [fileName]="fileName()"
                [imgUrl]="url()"
                [print]="print$"
                (imgLoaded)="onContentLoaded()" />
        }
        @case (MediaViewerContentType.APPLICATION_JSON) {
            <apcam-jsonviewer
                [download]="download$"
                [fileName]="fileName()"
                [jsonUrl]="url()"
                (jsonLoaded)="onContentLoaded()" />
        }
        <!-- Not a supported format -->
        @default {
            <section
                class="flex flex-col gap-8 justify-center items-center pt-12 px-4">
                <mat-icon
                    color="accent"
                    [style.width]="'72px'"
                    [style.height]="'72px'"
                    [style.fontSize]="'72px'"
                    >error_outline
                </mat-icon>
                <p class="text-center">
                    {{ 'shared.mediaViewer.notAbleToDisplay' | translate }}
                </p>
            </section>
        }
    }
</div>
